<mat-card appearance="outlined">
    <mat-card-content>
        @if (isEditing()) {
            <form (submit)="save()">
                <!-- stream -->
                <sl-input type="text" placeholderKey="LiveStream.StreamUrlDe" [control]="formGroup.controls.stream.controls.de" />
                <sl-input type="text" placeholderKey="LiveStream.StreamUrlEn" [control]="formGroup.controls.stream.controls.en" />
                <sl-input type="text" placeholderKey="LiveStream.StreamUrlFr" [control]="formGroup.controls.stream.controls.fr" />
                <sl-input type="text" placeholderKey="LiveStream.StreamUrlIt" [control]="formGroup.controls.stream.controls.it" />

                <!-- zoom settings -->
                <sl-input type="text" placeholderKey="LiveStream.ZoomId" [control]="formGroup.controls.zoom.controls.id" />
                <sl-input type="text" placeholderKey="LiveStream.ZoomPassword" [control]="formGroup.controls.zoom.controls.password" />

                <button type="submit" hidden></button>
            </form>
        } @else {
            @if (!isLoadingCheckedIn()) {
                @if (!isCheckedIn()) {
                    <div class="not-checked-in-container">
                        <div class="not-checked-in">
                            <div>
                                <div class="title">
                                    {{ 'LiveStream.Title' | translate }}
                                </div>
                                <div>
                                    {{ 'LiveStream.NotCheckedInMessage' | translate }}
                                </div>
                                <button class="enter-button" [disabled]="isLoading()" mat-flat-button (click)="checkIn()" color="primary">
                                    {{ 'GeneralMeeting.CheckIn' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                } @else {
                    <div class="w-100 h-100">
                        @if (isLoading()) {
                            <div class="w-100 h-100 d-flex align-items-center justify-content-center">
                                <mat-spinner [diameter]="32" />
                            </div>
                        } @else if (!isEditing() && !!iframeUrl()) {
                            <div class="iframe-container">
                                @if (!isZoomConnected()) {
                                    <iframe #iframe [src]="iframeUrl()" class="iframe"></iframe>
                                } @else {
                                    <div class="iframe-placeholder-during-zoom">
                                        <mat-icon inline>pause_circle_outline</mat-icon>
                                        <p>{{ 'LiveStream.PausedDuringZoom' | translate }}</p>
                                    </div>
                                }
                            </div>
                        }
                    </div>
                }
            } @else {
                <div class="not-checked-in-container">
                    <mat-spinner [diameter]="32" />
                </div>
            }
        }
    </mat-card-content>
    @if (canEdit() || (canRequestToSpeak() && isCheckedIn())) {
        <mat-card-actions>
            @if (canEdit() && !isEditing()) {
                <button mat-button (click)="isEditing.set(true)">
                    <mat-icon>edit</mat-icon>
                    {{ 'General.Edit' | translate }}
                </button>
            } @else if (canEdit()) {
                <button mat-button [disabled]="isSaving()" (click)="save()">
                    <mat-icon>save</mat-icon>
                    {{ 'General.Save' | translate }}
                </button>
            }

            @if (hasZoomSettings() && isCheckedIn()) {
                <button
                    mat-button
                    color="primary"
                    class="request-to-speak-btn"
                    [disabled]="!canRequestToSpeak()"
                    (click)="requestToSpeak()">
                    <mat-icon>record_voice_over</mat-icon>
                    {{ 'LiveStream.RequestToSpeak' | translate }}
                </button>
            }
        </mat-card-actions>
    }
</mat-card>
